module.exports = "/_next/static/images/38-1-17a098e49f7712d7733d569471f3e6b3.jpg";